<template>
  <div>
    <PageHeader
      image="images/install_smoke_alarms.jpg"
      title="place.where"
      content="place.protect"
      buttonText="place.learn_more"
      scrollTo="locations-header"
    />
    <div class="types-page-main-container">
      <div class="main-header" id="locations-header">
        <h2 class="main-header-title" id="types"
          >{{ toLocal("place.where_exactly") }}<br />
          {{ toLocal("place.smoke_alarms_installed") }}</h2
        >
        <span class="main-header-content">
          {{ toLocal("place.the_placement") }}
        </span>
        <span class="main-header-content">
          {{ toLocal("place.although") }}
        </span>
      </div>
      <div class="recommendations">
        <div class="row has-cols">
          <div class="col left" v-html="toLocal('place.according')"></div>
          <div class="col">
            <div class="card red">
              <p>
                <span class="semibold">{{ toLocal("place.note") }}:</span>
                {{ toLocal("place.apartaments") }}
              </p>
            </div>
          </div>
        </div>
        <div class="content-column">
          <div class="row">
            <div class="arrow-right">
              <svg
                width="12"
                height="23"
                viewBox="0 0 12 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 11.5L-6.59077e-08 22.3253L8.80472e-07 0.674682L12 11.5Z"
                  fill="#483A5B"
                />
              </svg>
            </div>
            <p v-html="toLocal('place.also_recommend')"></p>
          </div>
          <div class="row">
            <div class="arrow-right">
              <svg
                width="12"
                height="23"
                viewBox="0 0 12 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 11.5L-6.59077e-08 22.3253L8.80472e-07 0.674682L12 11.5Z"
                  fill="#483A5B"
                />
              </svg>
            </div>
            <p v-html="toLocal('place.makes_sense')"></p>
          </div>
          <div class="row white">
            <p v-html="toLocal('place.in_general')"></p>
          </div>
          <div class="row">
            <div class="arrow-right">
              <svg
                width="12"
                height="23"
                viewBox="0 0 12 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 11.5L-6.59077e-08 22.3253L8.80472e-07 0.674682L12 11.5Z"
                  fill="#483A5B"
                />
              </svg>
            </div>
            <p v-html="toLocal('place.before_installing')"></p>
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="main-content-red-bar">
          <div class="info">
            <div class="row">
              <div class="legend">
                <h3 class="legend-title">
                  {{ toLocal("place.location_req") }}
                </h3>
                <div
                  class="legend-item"
                  v-for="(item, index) in legend"
                  :key="index"
                >
                  <div
                    class="legend-color"
                    :style="{ 'background-color': item.color }"
                  ></div>
                  <div class="legend-text">{{ toLocal(item.text) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="house">
            <HouseComponent/>
          </div>
        </div>
        <div class="consider-container">
          <h2>{{ toLocal("place.what_to_consider") }}</h2>
          <span class="even-text" v-html="toLocal('place.determined')"></span>
          <div class="card wheat mb-40">
            <p>
              {{ toLocal("place.many_european") }}
            </p>
            <p>
              {{ toLocal("place.addition") }}
            </p>
          </div>
          <h2>{{ toLocal("place.installation_room") }}</h2>
          <div class="row has-cols">
            <div class="col left">
              <div class="row">
                <div class="block-with-number">1</div>
                <p v-html="toLocal('place.smoke_rises')"></p>
              </div>
              <div class="row">
                <div class="block-with-number">2</div>
                <p v-html="toLocal('place.rawlplug')"></p>
              </div>
              <div class="row">
                <div class="block-with-number">3</div>
                <p v-html="toLocal('place.centrally')"></p>
              </div>
              <div class="row">
                <div class="block-with-number">4</div>
                <p v-html="toLocal('place.basement')"></p>
              </div>
            </div>
            <div class="col">
              <div class="card red">
                <h4>{{ toLocal("place.never_paint") }}</h4>
                <p>
                  {{ toLocal("place.paint") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="locations">
          <div class="content-section">
            <h2>{{ toLocal("place.siting") }}</h2>
            <h4>{{ toLocal("place.smoke") }}</h4>
            <div class="location-container">
              <div
                class="location"
                v-for="(location, index) in locations1"
                :key="index"
              >
                <img :src="require(`@/assets/${location.img}`)" />
                <p>{{ toLocal(location.text) }}</p>
              </div>
              <div class="location">
                <svg width="432" height="268" viewBox="0 0 432 268" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.5">
                  <path d="M177.571 31.8442H33.2648V262.885H177.571V31.8442Z" fill="#F39964"/>
                  </g>
                  <path d="M109.914 155.475C114.463 155.475 118.151 151.788 118.151 147.239C118.151 142.69 114.463 139.002 109.914 139.002C105.365 139.002 101.678 142.69 101.678 147.239C101.678 151.788 105.365 155.475 109.914 155.475Z" fill="white"/>
                  <path d="M109.914 140.767C106.384 140.767 103.527 143.625 103.527 147.239C103.527 150.769 106.384 153.71 109.914 153.71C113.444 153.71 116.302 150.853 116.302 147.239C116.302 143.625 113.444 140.767 109.914 140.767ZM109.914 157.156C104.451 157.156 99.9129 152.702 99.9129 147.155C99.9129 141.608 104.367 137.153 109.914 137.153C115.461 137.153 119.916 141.608 119.916 147.155C119.916 152.702 115.461 157.156 109.914 157.156Z" fill="#483A5B"/>
                  <path d="M111.007 131.606H108.654V162.535H111.007V131.606Z" fill="#483A5B"/>
                  <path d="M125.715 146.23H94.8702V148.584H125.715V146.23Z" fill="#483A5B"/>
                  <path d="M174.881 80.0866H180.681V38.4001L197.322 38.148L202.112 30.4158H180.681V17.893L174.797 13.9429V30.4158H166.477V38.148H174.797L174.881 80.0866Z" fill="#483A5B"/>
                  <path d="M96.7192 77.6493H82.8517V37.2234H96.7192V77.6493ZM38.0555 95.5509V80.0866H80.4144V95.5509H38.0555ZM59.1509 37.2234H80.4144V74.4555L59.1509 37.2234ZM38.3076 53.5282L38.0555 53.9484V37.2234H56.7136L56.5455 37.3074L78.5654 75.8003L38.3076 53.5282ZM38.0555 56.1336L77.0526 77.6493H38.0555V56.1336ZM32.0883 36.9713L32.1723 109.587H37.9714V97.9042H82.8517V83.3643V80.0866H99.1565V36.9713H111.763L111.679 30.6679H38.0555V5.62232L32.2564 0.57959V30.3317H8.97577L13.2621 36.8872L32.0883 36.9713Z" fill="#483A5B"/>
                  <path d="M180.681 261.036V138.414H174.881V261.036L37.4672 260.448L37.8034 166.737H31.9202L31.4999 260.448H13.6823L9.05981 266.751L202.112 267.34L196.733 260.784L180.681 261.036Z" fill="#483A5B"/>
                  <path d="M52.217 142.93L50.5808 144.621L97.6351 190.143L99.2713 188.452L52.217 142.93Z" fill="#C0554B"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M49.8218 147.071L47.2164 139.675L54.6965 142.028L49.8218 147.071Z" fill="#C0554B"/>
                  <path d="M166.072 120.652L114.504 188.506L116.378 189.93L167.946 122.076L166.072 120.652Z" fill="#C0554B"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M169.082 124.463L170.511 116.73L163.451 120.176L169.082 124.463Z" fill="#C0554B"/>
                  <path d="M54.2794 52.4023L52.0742 53.2239L99.1359 179.553L101.341 178.732L54.2794 52.4023Z" fill="#C0554B"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M50.2421 55.1253L51.0825 47.3091L56.8817 52.688L50.2421 55.1253Z" fill="#C0554B"/>
                  <path d="M119.926 203.919C127.548 198.783 128.596 187.006 122.267 177.613C115.938 168.221 104.629 164.77 97.0073 169.906C89.3856 175.042 88.3374 186.819 94.6663 196.211C100.995 205.604 112.304 209.055 119.926 203.919Z" fill="#1E1726"/>
                  <path d="M118.356 204.133C125.593 199.257 126.392 187.783 120.141 178.507C113.89 169.23 102.956 165.662 95.7188 170.538C88.482 175.415 87.6829 186.888 93.9339 196.165C100.185 205.442 111.119 209.01 118.356 204.133Z" fill="#DBE2EE"/>
                  <path d="M109.766 197.655C113.304 195.182 113.521 189.384 110.25 184.704C106.979 180.025 101.46 178.237 97.9215 180.71C94.3835 183.183 94.1669 188.981 97.4377 193.66C100.709 198.34 106.228 200.128 109.766 197.655Z" fill="#BE544A"/>
                  <path d="M108.563 195.933C111.378 193.965 111.547 189.348 108.941 185.619C106.335 181.891 101.94 180.464 99.1252 182.432C96.31 184.4 96.1405 189.017 98.7465 192.745C101.353 196.474 105.747 197.901 108.563 195.933Z" fill="#DBE2EE"/>
                  <path d="M109.578 190.858C109.41 189.681 108.99 188.505 108.233 187.412C106.216 184.471 102.602 183.462 100.333 185.059C98.9884 185.983 98.3161 187.58 98.4001 189.345C97.8118 187.076 98.3161 184.807 99.997 183.63C102.35 182.033 105.964 183.21 108.065 186.236C109.074 187.748 109.578 189.429 109.578 190.858Z" fill="white"/>
                  <path d="M112.856 176.822C112.772 176.822 112.688 176.822 112.688 176.738C110.755 174.889 106.048 172.452 102.266 172.62C102.098 172.62 102.014 172.536 101.93 172.368C101.93 172.2 102.014 172.116 102.182 172.032C106.3 171.864 111.091 174.469 113.024 176.318C113.108 176.402 113.108 176.57 113.024 176.738C113.024 176.822 112.94 176.822 112.856 176.822Z" fill="#1E1726"/>
                  <path d="M110.839 178.083C110.755 178.083 110.671 178.083 110.671 177.999C108.654 176.15 105.208 174.805 102.35 174.805C102.182 174.805 102.098 174.637 102.098 174.553C102.098 174.385 102.266 174.301 102.35 174.301C105.376 174.301 108.906 175.646 111.091 177.663C111.175 177.747 111.259 177.915 111.091 178.083C111.007 178.083 110.923 178.083 110.839 178.083Z" fill="#1E1726"/>
                  <path d="M108.99 179.512C108.906 179.512 108.822 179.512 108.822 179.428C107.141 177.915 104.704 176.99 102.686 177.075C102.518 177.075 102.35 176.99 102.35 176.822C102.35 176.654 102.434 176.486 102.602 176.486C104.872 176.318 107.393 177.327 109.158 179.008C109.242 179.092 109.242 179.26 109.158 179.428C109.158 179.428 109.074 179.512 108.99 179.512Z" fill="#1E1726"/>
                  <text fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="69.2891" y="19.9">{{toLocal('house.bathroom')}}</tspan></text>
                  <text transform="translate(186 141.969) rotate(-90)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0.40625" y="15.9">{{toLocal('house.bedroom')}}</tspan></text>
                  <text transform="translate(0 168) rotate(-90)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0" y="15.9">{{toLocal('house.bedroom')}}</tspan></text>
                  <text fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="18" font-weight="500" letter-spacing="0em"><tspan x="243" y="96.4">&bull; {{toLocal('house.between1')}} </tspan><tspan x="243" y="118.4">{{toLocal('house.between2')}}&#10;</tspan><tspan x="243" y="140.4">&bull; {{toLocal('house.away')}}&#10;</tspan><tspan x="243" y="162.4">&bull; {{toLocal('house.within1')}} </tspan><tspan x="243" y="184.4">{{toLocal('house.within2')}} </tspan><tspan x="243" y="206.4">{{toLocal('house.within3')}}</tspan></text>
                  <path d="M53.1319 165.388C53.0947 165.427 53.0497 165.442 52.9968 165.436C52.959 165.429 52.9284 165.399 52.905 165.346L50.3178 158.686C50.294 158.604 50.3081 158.536 50.3601 158.482L51.1291 157.69C51.1811 157.637 51.2526 157.624 51.3436 157.653L58.0654 160.032L58.1225 160.065C58.1837 160.125 58.1808 160.189 58.114 160.258L57.3003 161.095C57.2409 161.157 57.1694 161.169 57.0859 161.133L51.9547 159.205C51.8865 159.184 51.8643 159.207 51.8879 159.274L53.9651 164.347C54.0041 164.429 53.9938 164.501 53.9344 164.562L53.1319 165.388ZM61.8312 167.502C61.6201 168.026 61.2768 168.532 60.8013 169.022C60.4075 169.428 59.9822 169.743 59.5254 169.969C58.8963 170.28 58.2604 170.376 57.6175 170.257C56.982 170.13 56.3888 169.8 55.8378 169.265C55.2869 168.73 54.946 168.124 54.8154 167.447C54.6924 166.777 54.7846 166.123 55.092 165.485C55.2159 165.189 55.4634 164.835 55.8345 164.422C55.9088 164.346 55.9842 164.345 56.0607 164.419L56.9445 165.277C57.0211 165.351 57.0222 165.427 56.9479 165.503C56.6957 165.794 56.5294 166.026 56.449 166.201C56.2506 166.558 56.1729 166.921 56.2161 167.29C56.2669 167.667 56.4492 168.007 56.7629 168.312C57.3445 168.877 57.9911 168.992 58.7027 168.657C59.0251 168.524 59.3647 168.274 59.7213 167.906C60.1003 167.516 60.3771 167.109 60.5519 166.684C60.7983 166.001 60.6461 165.392 60.0951 164.857C59.965 164.731 59.7448 164.629 59.4343 164.55C59.3889 164.536 59.3585 164.521 59.3432 164.506C59.3049 164.469 59.2929 164.42 59.3071 164.36L59.4505 163.339C59.4649 163.294 59.4832 163.26 59.5055 163.237C59.5278 163.214 59.5653 163.198 59.618 163.19L63.6204 162.995C63.6806 162.979 63.6915 162.953 63.6532 162.915L60.6 159.951C60.5234 159.876 60.5223 159.801 60.5966 159.725L61.2988 159.001C61.3731 158.925 61.4485 158.924 61.525 158.998L65.9787 163.323C66.0552 163.397 66.0563 163.472 65.982 163.549L65.1795 164.375C65.1424 164.413 65.0786 164.441 64.9884 164.457L61.3935 164.669C61.3633 164.669 61.3446 164.681 61.3374 164.703C61.3376 164.718 61.3455 164.741 61.361 164.771C61.7142 165.188 61.9243 165.63 61.9915 166.097C62.0662 166.556 62.0127 167.024 61.8312 167.502ZM73.944 175.16C74.5256 175.725 74.8138 176.347 74.8087 177.026C74.8111 177.697 74.5113 178.343 73.9094 178.962L70.1868 182.796C70.1125 182.873 70.0371 182.874 69.9606 182.8L69.0997 181.964C69.0232 181.889 69.0221 181.814 69.0964 181.737L72.5961 178.133C72.9676 177.751 73.154 177.344 73.1552 176.914C73.1715 176.484 73.0036 176.098 72.6516 175.756C72.2996 175.415 71.9049 175.247 71.4675 175.253C71.0301 175.26 70.6294 175.45 70.2653 175.825L66.7433 179.453C66.669 179.529 66.5936 179.53 66.5171 179.456L65.6562 178.62C65.5797 178.546 65.5785 178.47 65.6528 178.394L69.1526 174.79C69.5241 174.407 69.7105 174.001 69.7117 173.571C69.728 173.14 69.5601 172.754 69.2081 172.413C68.8561 172.071 68.4652 171.907 68.0355 171.921C67.6134 171.942 67.2203 172.14 66.8562 172.515L63.3342 176.142C63.2599 176.219 63.1845 176.22 63.108 176.146L62.2356 175.299C62.1591 175.224 62.158 175.149 62.2323 175.072L67.6825 169.459C67.7568 169.383 67.8322 169.382 67.9087 169.456L68.7811 170.303C68.8576 170.377 68.8587 170.453 68.7844 170.529L68.4055 170.92C68.3906 170.935 68.3833 170.95 68.3835 170.965C68.3914 170.988 68.4104 170.999 68.4406 170.998C69.1711 170.92 69.8577 171.192 70.5005 171.817C70.8908 172.196 71.1493 172.595 71.2762 173.016C71.4105 173.429 71.413 173.855 71.2837 174.294C71.2769 174.347 71.2999 174.369 71.3526 174.361C71.826 174.241 72.2826 174.253 72.7222 174.398C73.1694 174.549 73.5767 174.804 73.944 175.16Z" fill="black"/>
<path d="M61.2419 116.079C61.1919 116.097 61.1444 116.092 61.0996 116.063C61.0685 116.041 61.0537 116.001 61.0552 115.943L61.5936 108.819C61.6077 108.734 61.6498 108.678 61.7198 108.653L62.7553 108.27C62.8253 108.244 62.8951 108.263 62.9648 108.329L68.0032 113.374L68.0404 113.429C68.07 113.509 68.0398 113.565 67.9497 113.599L66.8543 114.004C66.7742 114.033 66.7044 114.014 66.6448 113.945L62.8466 109.993C62.7944 109.944 62.7644 109.955 62.7566 110.026L62.443 115.498C62.4426 115.589 62.4024 115.65 62.3223 115.679L61.2419 116.079ZM61.4933 118.973C61.4748 118.923 61.475 118.878 61.4939 118.836C61.5265 118.802 61.5715 118.785 61.6289 118.787L71.8924 118.864C71.9161 118.866 71.9311 118.861 71.9374 118.847C71.9537 118.83 71.9582 118.811 71.9508 118.791L70.6135 115.174C70.5987 115.134 70.5713 115.122 70.5313 115.137L69.826 115.397C69.7259 115.434 69.6574 115.403 69.6204 115.303L69.2875 114.402C69.2505 114.302 69.282 114.234 69.3821 114.197L71.2429 113.509C71.3429 113.472 71.4114 113.503 71.4484 113.603L73.729 119.771C73.766 119.871 73.7344 119.94 73.6344 119.977L72.629 120.348C72.5889 120.363 72.5252 120.375 72.4378 120.385L62.1349 120.339C62.0438 120.339 61.9834 120.299 61.9538 120.219L61.4933 118.973ZM63.8498 125.346C63.7462 125.066 63.7511 124.803 63.8646 124.556C63.9781 124.309 64.1749 124.134 64.4551 124.031C64.7352 123.927 64.9986 123.932 65.2452 124.046C65.4919 124.159 65.667 124.356 65.7706 124.636C65.8742 124.916 65.8692 125.179 65.7557 125.426C65.6422 125.673 65.4454 125.848 65.1653 125.951C64.8852 126.055 64.6218 126.05 64.3751 125.937C64.1285 125.823 63.9533 125.626 63.8498 125.346ZM71.8776 132.756C71.4781 133.029 71.0432 133.252 70.573 133.426C70.1028 133.6 69.6455 133.701 69.2009 133.729C68.4903 133.775 67.8451 133.599 67.2652 133.199C66.699 132.806 66.279 132.239 66.0053 131.499C65.7352 130.768 65.6841 130.076 65.8519 129.423C66.0197 128.77 66.3749 128.223 66.9174 127.784C67.1606 127.58 67.3853 127.434 67.5917 127.347L67.6217 127.336C67.7018 127.306 67.7584 127.336 67.7917 127.426L68.2301 128.612C68.2634 128.702 68.2369 128.769 68.1505 128.812C68.0842 128.848 67.9884 128.912 67.8631 129.003C67.5337 129.25 67.3088 129.55 67.1886 129.901C67.0821 130.259 67.101 130.633 67.2452 131.023C67.3969 131.433 67.6346 131.738 67.9582 131.936C68.2956 132.141 68.6829 132.22 69.1201 132.172C69.356 132.164 69.6591 132.092 70.0293 131.955C70.3594 131.833 70.6534 131.69 70.9114 131.527C71.2656 131.316 71.4892 131.029 71.582 130.665C71.6885 130.307 71.6641 129.918 71.5087 129.498C71.3644 129.108 71.1449 128.791 70.8502 128.547C70.5654 128.3 70.2613 128.185 69.9379 128.202C69.8368 128.205 69.7714 128.167 69.7418 128.087L69.2979 126.886C69.2609 126.786 69.2925 126.718 69.3925 126.681L75.305 124.495C75.4051 124.458 75.4736 124.489 75.5106 124.589L77.5858 130.202C77.6228 130.302 77.5913 130.37 77.4912 130.407L76.5458 130.757C76.4458 130.794 76.3773 130.762 76.3403 130.662L74.7644 126.4C74.7496 126.36 74.7222 126.348 74.6822 126.363L71.5403 127.507C71.4803 127.529 71.4745 127.56 71.523 127.599C71.8219 127.761 72.0787 127.979 72.2934 128.252C72.5218 128.532 72.7008 128.846 72.8303 129.197C73.0892 129.897 73.1361 130.562 72.9709 131.192C72.8094 131.831 72.445 132.353 71.8776 132.756ZM79.7111 144.438C79.9922 145.198 79.9841 145.883 79.6867 146.494C79.3992 147.1 78.8503 147.554 78.04 147.853L73.0279 149.706C72.9278 149.743 72.8593 149.712 72.8223 149.612L72.4061 148.486C72.3692 148.386 72.4007 148.318 72.5007 148.281L77.2127 146.539C77.7129 146.354 78.0563 146.067 78.2429 145.68C78.4431 145.299 78.4582 144.878 78.288 144.418C78.1178 143.958 77.8341 143.636 77.4367 143.454C77.0393 143.271 76.5955 143.27 76.1052 143.451L71.3632 145.205C71.2632 145.242 71.1947 145.21 71.1577 145.11L70.7415 143.985C70.7045 143.884 70.736 143.816 70.8361 143.779L75.5481 142.037C76.0483 141.852 76.3917 141.565 76.5782 141.178C76.7785 140.797 76.7935 140.376 76.6234 139.916C76.4532 139.456 76.1713 139.139 75.7776 138.967C75.3876 138.804 74.9475 138.813 74.4572 138.994L69.7152 140.748C69.6152 140.785 69.5467 140.753 69.5097 140.653L69.088 139.513C69.051 139.413 69.0825 139.344 69.1825 139.307L76.5207 136.594C76.6207 136.557 76.6892 136.588 76.7262 136.688L77.1479 137.829C77.1849 137.929 77.1534 137.997 77.0534 138.034L76.5431 138.223C76.5231 138.23 76.51 138.241 76.5037 138.255C76.5011 138.278 76.5135 138.296 76.5409 138.309C77.2339 138.553 77.7357 139.095 78.0465 139.936C78.2351 140.446 78.296 140.918 78.2291 141.352C78.1722 141.783 77.9906 142.168 77.6844 142.509C77.6555 142.554 77.6666 142.584 77.7177 142.599C78.1967 142.695 78.6033 142.903 78.9377 143.223C79.2757 143.552 79.5335 143.958 79.7111 144.438Z" fill="black"/>
<path d="M145.777 172.496C145.82 172.528 145.841 172.571 145.841 172.624C145.838 172.662 145.812 172.696 145.763 172.726L139.465 176.1C139.385 176.134 139.316 176.128 139.257 176.083L138.377 175.416C138.318 175.37 138.297 175.301 138.315 175.207L139.863 168.246L139.889 168.186C139.94 168.118 140.004 168.113 140.081 168.171L141.011 168.877C141.079 168.929 141.1 168.998 141.074 169.085L139.782 174.412C139.768 174.483 139.794 174.502 139.858 174.471L144.642 171.794C144.719 171.746 144.792 171.747 144.86 171.799L145.777 172.496ZM146.823 163.604C147.368 163.75 147.912 164.029 148.456 164.442C148.906 164.784 149.271 165.168 149.55 165.594C149.935 166.181 150.107 166.801 150.067 167.453C150.019 168.099 149.762 168.728 149.298 169.34C148.833 169.952 148.273 170.363 147.617 170.575C146.967 170.778 146.307 170.766 145.636 170.538C145.327 170.451 144.946 170.248 144.491 169.93C144.406 169.865 144.396 169.79 144.46 169.705L145.205 168.724C145.27 168.639 145.344 168.629 145.429 168.693C145.748 168.909 145.999 169.046 146.182 169.104C146.561 169.258 146.931 169.291 147.292 169.204C147.66 169.108 147.976 168.885 148.24 168.537C148.73 167.891 148.766 167.236 148.348 166.57C148.177 166.266 147.887 165.959 147.479 165.649C147.046 165.32 146.608 165.095 146.165 164.973C145.458 164.811 144.872 165.036 144.407 165.647C144.298 165.792 144.223 166.023 144.182 166.34C144.174 166.387 144.163 166.419 144.15 166.436C144.118 166.479 144.071 166.496 144.009 166.49L142.978 166.471C142.931 166.462 142.895 166.448 142.87 166.429C142.844 166.409 142.824 166.374 142.81 166.323L142.132 162.373C142.109 162.315 142.081 162.308 142.049 162.35L139.475 165.74C139.411 165.825 139.336 165.835 139.251 165.771L138.448 165.161C138.363 165.097 138.353 165.022 138.417 164.937L142.171 159.992C142.236 159.907 142.311 159.897 142.396 159.962L143.313 160.658C143.356 160.69 143.391 160.75 143.418 160.838L144.063 164.381C144.067 164.411 144.08 164.428 144.104 164.433C144.119 164.431 144.14 164.42 144.168 164.401C144.54 164 144.953 163.738 145.408 163.615C145.855 163.485 146.326 163.481 146.823 163.604ZM152.959 150.652C153.449 150.006 154.032 149.645 154.706 149.568C155.372 149.484 156.05 149.704 156.738 150.226L160.994 153.458C161.079 153.522 161.089 153.597 161.025 153.682L160.299 154.638C160.235 154.723 160.16 154.733 160.075 154.668L156.073 151.63C155.649 151.308 155.223 151.172 154.796 151.223C154.367 151.259 154.004 151.472 153.707 151.863C153.41 152.254 153.292 152.666 153.351 153.099C153.41 153.533 153.648 153.907 154.065 154.223L158.092 157.281C158.177 157.345 158.187 157.42 158.122 157.505L157.397 158.461C157.332 158.546 157.257 158.556 157.173 158.491L153.171 155.453C152.746 155.131 152.32 154.995 151.893 155.046C151.464 155.082 151.101 155.295 150.805 155.686C150.508 156.077 150.392 156.485 150.458 156.91C150.53 157.326 150.775 157.692 151.191 158.008L155.218 161.066C155.303 161.13 155.313 161.205 155.249 161.29L154.513 162.258C154.449 162.343 154.374 162.354 154.289 162.289L148.057 157.558C147.973 157.493 147.962 157.419 148.027 157.334L148.762 156.365C148.827 156.28 148.901 156.27 148.986 156.335L149.42 156.664C149.437 156.676 149.453 156.682 149.468 156.68C149.489 156.669 149.498 156.649 149.493 156.619C149.327 155.903 149.515 155.189 150.056 154.475C150.385 154.042 150.751 153.737 151.153 153.56C151.547 153.377 151.969 153.323 152.421 153.398C152.475 153.398 152.494 153.373 152.479 153.321C152.303 152.866 152.26 152.411 152.35 151.957C152.446 151.495 152.649 151.06 152.959 150.652Z" fill="black"/>
                  </svg>

                <p>{{ toLocal("place.heat_alarms") }}</p>
              </div>
              <div class="location">
                <svg width="310" height="211" viewBox="0 0 310 211" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <text transform="translate(253 26)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0.0625" y="15.9">{{toLocal('house.heat')}}</tspan></text>
                  <text transform="translate(10.0003 81)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0.148438" y="15.9">{{toLocal('house.smoke')}}</tspan></text>
                  <path d="M21.7408 210.73H18.0312V202.464V199.145V197.258L18.8772 196.542L21.155 194.85L21.3503 194.655L21.7408 194.395V201.228V210.73Z" fill="#F1F2F2"/>
                  <path d="M100.16 210.73H21.8682V201.163V198.625L26.9444 199.406L100.16 210.73Z" fill="#A7A9AC"/>
                  <path d="M309.913 118.508V210.727H100.875L26.9444 199.403L21.8682 198.622L58.3781 186.192L62.6734 184.76L128.86 162.242L134.001 160.485L196.413 139.269L200.839 137.772L209.169 134.909L212.683 133.737L213.594 133.412L217.044 132.24L217.629 132.045L283.816 109.527L284.011 109.592L286.028 110.243L309.913 118.508Z" fill="#D1D3D4"/>
                  <path d="M282.971 210.731H133.287V160.814L133.807 160.88L134.003 160.945L137.061 161.53L196.414 173.05L200.71 173.896H200.775L213.921 176.434L215.157 176.629L217.956 177.215L219.192 177.475L220.689 177.735L221.926 177.996L223.358 178.256L224.659 178.516L227.848 179.102L229.085 179.362L229.931 179.492L230.907 179.688L231.167 179.753L232.143 179.948L233.64 180.208L233.835 180.273L234.877 180.469L235.072 180.534L236.504 180.794L237.35 180.989L237.74 181.054L240.994 181.64L276.723 188.604L277.699 188.734L282.906 189.775L282.971 210.731Z" fill="#A7A9AC"/>
                  <path d="M309.916 182.746V210.731H251.995V192.899L253.036 192.703L256.29 192.183L276.725 188.603L277.701 188.408L307.573 183.137L309.916 182.746Z" fill="#A7A9AC"/>
                  <path d="M275.617 210.73L275.552 207.281L277.699 207.346L281.669 207.476L281.734 210.73H275.617Z" fill="#939598"/>
                  <path d="M21.8692 198.624L284.012 110.245V103.217L21.1533 194.785L21.8692 198.624Z" fill="#F1F2F2"/>
                  <path d="M203.181 138.75L201.164 138.165L200.839 138.1V139.141V139.596L200.708 173.894L200.578 210.729H277.633V165.433L309.522 173.633L309.913 173.698V168.817L203.181 138.75Z" fill="#E6E7E8"/>
                  <path d="M134.069 210.729H128.928L128.863 164.327V162.57V159.901L132.703 158.925L134.004 158.6V160.942V162.57L134.069 210.729Z" fill="#F1F2F2"/>
                  <path d="M307.571 174.087L277.7 166.538V165.432L309.914 173.502L307.571 174.087Z" fill="#939598"/>
                  <path d="M231.166 187.952L233.769 188.603V188.538L231.166 187.952ZM231.166 187.952L233.769 188.603V188.538L231.166 187.952ZM256.287 192.182L243.141 189.319L240.993 188.863L237.739 188.147L236.503 187.887L235.071 187.562L234.876 187.497L233.834 187.301L231.231 186.716L230.971 186.651L227.847 186L224.658 185.284L220.688 184.438L219.257 184.112L213.985 182.941L209.56 181.965V186L252.057 195.111L258.305 196.413V192.573L256.287 192.182ZM256.938 194.916L251.992 193.875L210.731 185.024V183.527L218.996 185.349L219.257 185.414L230.971 187.952L231.231 188.017L233.834 188.603L237.804 189.449L253.098 192.768L257.068 193.614V194.916H256.938ZM231.166 187.952L233.769 188.603V188.538L231.166 187.952ZM231.166 187.952L233.769 188.603V188.538L231.166 187.952Z" fill="#A7A9AC"/>
                  <path d="M213.921 170.965V184.176L218.998 185.348L219.258 185.413V171.941L213.921 170.965ZM217.956 183.851L215.158 183.2V172.462L217.956 172.982V183.851Z" fill="#A7A9AC"/>
                  <path d="M220.69 175V185.673L224.66 186.454V175.781L220.69 175ZM223.358 184.957L221.926 184.632V176.497L223.358 176.822V184.957Z" fill="#A7A9AC"/>
                  <path d="M227.846 175.844V187.103L230.97 187.884L231.23 187.949V176.69L227.846 175.844ZM229.082 177.471L229.993 177.666V186.322L229.082 186.126V177.471Z" fill="#A7A9AC"/>
                  <path d="M233.834 178.189L231.231 177.669L230.97 177.604V187.886L231.231 187.951L233.834 188.472L234.875 188.667V178.385L233.834 178.189ZM232.142 179.101L233.573 179.426V187.171L232.142 186.845V179.101Z" fill="#A7A9AC"/>
                  <path d="M240.994 181.638L239.887 179.685L237.74 180.727L237.349 180.922L236.503 181.312H236.438L236.503 181.443L237.74 183.46L240.994 188.732L241.71 189.903L243.141 189.187L244.964 188.211L240.994 181.638ZM242.165 188.406L238.195 181.898L239.367 181.312L243.207 187.82L242.165 188.406Z" fill="#A7A9AC"/>
                  <path d="M233.836 175.066V188.603L237.806 189.384V176.368L233.836 175.066ZM236.504 187.887L235.073 187.562V176.758L236.504 177.279V187.887Z" fill="#A7A9AC"/>
                  <path d="M294.88 107.254L309.913 112.525V119.033L285.313 110.508L284.011 110.052V103.414L288.957 105.171L290.259 105.562L290.584 105.692L292.081 106.213L294.88 107.254Z" fill="#E6E7E8"/>
                  <path d="M200.84 135.887V139.596L200.775 173.893V210.729H196.479L196.414 173.047V141.093V137.904L196.935 137.644L200.84 135.887Z" fill="#F1F2F2"/>
                  <path d="M143.244 8.00553L309.914 74.7778V107.773L301.844 104.845L293.839 101.916L290.781 100.81L223.227 59.6792L213.335 53.6267L212.229 52.9108L208.584 50.6981L130.033 2.86419L129.447 2.47371L130.098 2.73403L130.488 2.92927L143.244 8.00553Z" fill="#939598"/>
                  <path d="M301.78 104.842L309.915 107.835V114.408L292.083 108.161L290.586 107.64V100.807L294.1 102.108L301.78 104.842Z" fill="#D1D3D4"/>
                  <path d="M21.8682 198.624L284.011 110.245V103.217L21.8682 194.394V198.624Z" fill="#F1F2F2"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 199.403L130.099 2.66602L296.379 103.475L17.25 199.403Z" fill="#E6E7E8"/>
                  <path d="M62.6767 183.005V183.136L107.907 168.232H107.972L108.688 168.037L108.949 167.972L128.863 161.138V160.357L62.6767 183.005ZM62.6767 183.005V183.136L108.363 168.102L128.863 161.073V160.292L62.6767 183.005ZM143.246 8.00486L130.035 0L13.0205 204.221L18.0317 202.529L21.6762 201.293L21.8714 201.228L26.9477 199.471L128.863 164.392L133.289 162.896L134.005 162.635L137.063 161.594L196.416 141.159L200.842 139.662L203.185 138.881L285.316 110.636L286.032 110.376L292.084 108.293L294.883 107.317L301.781 104.974H301.846L302.432 104.779L143.246 8.00486ZM21.6111 197.128V197.063L21.7412 196.867L21.9365 196.542L23.4333 194.004L23.4984 193.874L58.2512 133.219L62.2862 126.255L62.4814 125.865L62.7417 125.344L131.401 5.40165L208.521 52.1943L212.166 54.407L213.272 55.1229L290.522 101.981L293.256 103.608L290.522 104.584L288.895 105.17L283.949 106.862L213.532 131.071L212.621 131.397L208.521 132.829L163.941 148.187L132.703 158.926L128.798 160.227L62.6116 183.005L61.9608 183.201L58.3163 184.437L21.8063 196.998L21.6111 197.063V197.128ZM62.6767 183.005V183.136L107.907 168.232H107.972L108.688 168.037L128.863 161.073V160.292L62.6767 183.005ZM213.532 131.071L212.621 131.397L208.521 132.829L163.941 148.187L132.703 158.926L128.798 160.227L62.6116 183.005L61.9608 183.201L58.3163 184.437L21.8063 196.998L21.6111 197.063V197.648L21.6762 197.844L21.8063 197.779L58.3163 185.218L62.5465 183.786L107.777 168.232H107.842L108.558 168.037L108.818 167.972L128.733 161.399V162.635L133.158 161.138L133.679 160.943L133.874 160.878L196.286 139.857V139.337L200.712 137.84L209.042 134.976L212.491 133.805V132.373L213.402 132.048V131.071H213.532Z" fill="#A1A3A6"/>
                  <path d="M133.415 17.1809H131.072V93.0644H133.415V17.1809Z" fill="#C0554B"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M138.101 91.8926L132.243 103.607L126.386 91.8926H138.101Z" fill="#C0554B"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M126.386 18.3521L132.243 6.6377L138.101 18.3521H126.386Z" fill="#C0554B"/>
                  <path d="M304.64 57.0093H301.125V55.8379H304.64V57.0093ZM299.954 57.0093H296.439V55.8379H299.954V57.0093ZM295.203 57.0093H291.689V55.8379H295.203V57.0093ZM290.517 57.0093H287.003V55.8379H290.517V57.0093ZM285.831 57.0093H282.317V55.8379H285.831V57.0093ZM281.146 57.0093H277.631V55.8379H281.146V57.0093ZM276.46 57.0093H272.946V55.8379H276.46V57.0093ZM271.774 57.0093H268.26V55.8379H271.774V57.0093ZM267.023 57.0093H263.509V55.8379H267.023V57.0093ZM262.337 57.0093H258.823V55.8379H262.337V57.0093ZM257.652 57.0093H254.137V55.8379H257.652V57.0093ZM252.966 57.0093H249.452V55.8379H252.966V57.0093ZM248.28 57.0093H244.766V55.8379H248.28V57.0093ZM243.594 57.0093H240.08V55.8379H243.594V57.0093ZM238.844 57.0093H235.329V55.8379H238.844V57.0093ZM234.158 57.0093H230.643V55.8379H234.158V57.0093ZM229.472 57.0093H225.958V55.8379H229.472V57.0093ZM224.786 57.0093H221.272V55.8379H224.786V57.0093ZM220.1 57.0093H216.586V55.8379H220.1V57.0093ZM215.415 57.0093H211.9V55.8379H215.415V57.0093ZM210.664 57.0093H207.15V55.8379H210.664V57.0093ZM205.978 57.0093H202.464V55.8379H205.978V57.0093ZM201.292 57.0093H197.778V55.8379H201.292V57.0093ZM196.607 57.0093H193.092V55.8379H196.607V57.0093ZM191.921 57.0093H188.406V55.8379H191.921V57.0093ZM187.235 57.0093H183.721V55.8379H187.235V57.0093ZM182.484 57.0093H178.97V55.8379H182.484V57.0093ZM177.798 57.0093H174.284V55.8379H177.798V57.0093ZM173.113 57.0093H169.598V55.8379H173.113V57.0093ZM168.427 57.0093H164.912V55.8379H168.427V57.0093ZM163.741 57.0093H160.227V55.8379H163.741V57.0093ZM158.99 57.0093H155.476V55.8379H158.99V57.0093ZM154.304 57.0093H150.79V55.8379H154.304V57.0093ZM149.619 57.0093H146.104V55.8379H149.619V57.0093ZM144.933 57.0093H143.892V55.8379H144.933V57.0093Z" fill="#C0554B"/>
                  <path d="M0 109.594V108.423H2.73337V109.594H0ZM3.90481 109.594V108.423H7.41914V109.594H3.90481ZM8.59058 109.594V108.423H12.1049V109.594H8.59058ZM13.2764 109.529V108.358H16.7907V109.529H13.2764ZM17.9621 109.529V108.358H21.4764V109.529H17.9621ZM22.713 109.529V108.358H26.2273V109.529H22.713ZM27.3987 109.529V108.358H30.9131V109.529H27.3987ZM32.0845 109.464V108.293H35.5988V109.464H32.0845ZM36.7703 109.464V108.293H40.2846V109.464H36.7703ZM41.4561 109.464V108.293H44.9704V109.464H41.4561ZM46.1418 109.464V108.293H49.6562V109.464H46.1418ZM50.8927 109.464V108.293H54.407V109.464H50.8927ZM55.5784 109.399V108.228H59.0928V109.399H55.5784ZM60.2642 109.399V108.228H63.7785V109.399H60.2642ZM64.95 109.399V108.228H68.4643V109.399H64.95ZM69.6358 109.399V108.228H73.1501V109.399H69.6358ZM74.3215 109.334V108.163H77.8359V109.334H74.3215ZM79.0724 109.334V108.163H82.5867V109.334H79.0724ZM83.7582 109.334V108.163H87.2725V109.334H83.7582ZM88.4439 109.334V108.163H91.9583V109.334H88.4439ZM93.1297 109.334V108.163H96.644V109.334H93.1297ZM97.8155 109.269V108.098H101.33V109.269H97.8155ZM102.501 109.269V108.098H106.016V109.269H102.501ZM107.252 109.269V108.098H110.766V109.269H107.252ZM111.938 109.269V108.098H115.452V109.269H111.938ZM116.624 109.204V108.033H120.138V109.204H116.624ZM121.309 109.204V108.033H124.824V109.204H121.309ZM125.995 109.204V108.033H129.509V109.204H125.995ZM130.746 109.204V108.033H134.26V109.204H130.746ZM135.432 109.204V108.033H138.946V109.204H135.432ZM140.118 109.139V107.967H143.632V109.139H140.118ZM144.803 109.139V107.967H148.318V109.139H144.803ZM149.489 109.139V107.967H153.003V109.139H149.489ZM154.175 109.139V107.967H157.689V109.139H154.175ZM158.926 109.074V107.902H162.44V109.074H158.926ZM163.611 109.074V107.902H167.126V109.074H163.611Z" fill="#C0554B"/>
                  <path d="M171.631 49.9994C177.533 46.0226 178.344 36.9028 173.444 29.6298C168.543 22.3568 159.786 19.6847 153.884 23.6615C147.982 27.6383 147.17 36.7581 152.071 44.0311C156.972 51.3041 165.729 53.9762 171.631 49.9994Z" fill="#1E1826"/>
                  <path d="M170.432 50.22C176.036 46.4441 176.655 37.5596 171.814 30.3761C166.974 23.1925 158.507 20.4301 152.903 24.206C147.3 27.982 146.681 36.8664 151.521 44.05C156.362 51.2335 164.828 53.996 170.432 50.22Z" fill="#DCE3EF"/>
                  <path d="M163.783 45.2332C166.523 43.3182 166.691 38.8284 164.158 35.205C161.625 31.5816 157.351 30.1966 154.611 32.1116C151.872 34.0267 151.704 38.5165 154.237 42.1399C156.77 45.7633 161.044 47.1482 163.783 45.2332Z" fill="#C0554B"/>
                  <path d="M162.851 43.9006C165.031 42.3768 165.162 38.8012 163.144 35.9143C161.126 33.0273 157.723 31.9223 155.543 33.446C153.363 34.9698 153.232 38.5454 155.25 41.4324C157.268 44.3193 160.671 45.4244 162.851 43.9006Z" fill="#DCE3EF"/>
                  <path d="M163.613 39.9588C163.483 39.0477 163.158 38.1366 162.572 37.2906C161.01 35.0128 158.212 34.2318 156.455 35.4683C155.413 36.1842 154.893 37.4207 154.958 38.7874C154.502 37.0302 154.893 35.2731 156.194 34.3619C158.016 33.1254 160.815 34.0366 162.442 36.3794C163.223 37.4858 163.613 38.7874 163.613 39.9588Z" fill="white"/>
                  <path d="M166.151 29.0242C166.086 29.0242 166.021 29.0243 166.021 28.9592C164.524 27.5274 160.879 25.6401 157.951 25.7702C157.821 25.7702 157.756 25.7052 157.69 25.575C157.69 25.4448 157.756 25.3798 157.886 25.3147C161.075 25.1845 164.784 27.202 166.281 28.6338C166.346 28.6989 166.346 28.829 166.281 28.9592C166.281 29.0243 166.216 29.0242 166.151 29.0242Z" fill="#1E1826"/>
                  <path d="M164.589 30.001C164.524 30.001 164.458 30.001 164.458 29.9359C162.897 28.5041 160.228 27.4629 158.015 27.4629C157.885 27.4629 157.82 27.3327 157.82 27.2676C157.82 27.1375 157.95 27.0724 158.015 27.0724C160.358 27.0724 163.092 28.1137 164.784 29.6756C164.849 29.7407 164.914 29.8708 164.784 30.001C164.719 30.001 164.654 30.001 164.589 30.001Z" fill="#1E1826"/>
                  <path d="M163.158 31.1073C163.093 31.1073 163.028 31.1073 163.028 31.0422C161.726 29.8708 159.839 29.1549 158.277 29.22C158.147 29.22 158.017 29.1549 158.017 29.0247C158.017 28.8946 158.082 28.7644 158.212 28.7644C159.969 28.6342 161.922 29.4152 163.288 30.7168C163.353 30.7819 163.353 30.9121 163.288 31.0422C163.288 31.1073 163.223 31.1073 163.158 31.1073Z" fill="#1E1826"/>
                  <path d="M108.229 90.493C113.129 83.22 112.318 74.1003 106.416 70.1235C100.514 66.1467 91.757 68.8188 86.8563 76.0918C81.9556 83.3648 82.7672 92.4845 88.669 96.4613C94.5709 100.438 103.328 97.766 108.229 90.493Z" fill="#1E1826"/>
                  <path d="M108.821 90.5087C113.661 83.3251 113.042 74.4407 107.438 70.6647C101.835 66.8888 93.3679 69.6512 88.5275 76.8348C83.687 84.0184 84.3058 92.9028 89.9096 96.6788C95.5134 100.455 103.98 97.6923 108.821 90.5087Z" fill="#DCE3EF"/>
                  <path d="M106.047 88.5899C108.58 84.9665 108.412 80.4767 105.672 78.5617C102.933 76.6467 98.6587 78.0316 96.1259 81.655C93.5931 85.2785 93.7608 89.7682 96.5005 91.6833C99.2402 93.5983 103.514 92.2134 106.047 88.5899Z" fill="#C0554B"/>
                  <path d="M105.033 87.8826C107.051 84.9956 106.92 81.42 104.74 79.8963C102.56 78.3725 99.1571 79.4776 97.1391 82.3645C95.1211 85.2515 95.2524 88.8271 97.4324 90.3508C99.6123 91.8746 103.015 90.7696 105.033 87.8826Z" fill="#DCE3EF"/>
                  <path d="M96.6449 86.4266C96.7751 85.5155 97.1005 84.6044 97.6862 83.7583C99.2481 81.4805 102.047 80.6996 103.804 81.9361C104.845 82.652 105.366 83.8885 105.301 85.2552C105.756 83.498 105.366 81.7409 104.064 80.8297C102.242 79.5932 99.4433 80.5043 97.8163 82.8472C97.0354 83.9536 96.6449 85.2552 96.6449 86.4266Z" fill="white"/>
                  <path d="M94.1067 75.4918C94.1718 75.4918 94.2369 75.4918 94.2369 75.4268C95.7337 73.995 99.3782 72.1077 102.307 72.2378C102.437 72.2378 102.502 72.1727 102.567 72.0426C102.567 71.9124 102.502 71.8473 102.372 71.7823C99.183 71.6521 95.4734 73.6696 93.9765 75.1014C93.9115 75.1664 93.9115 75.2966 93.9765 75.4268C94.0416 75.4918 94.1067 75.4918 94.1067 75.4918Z" fill="#1E1826"/>
                  <path d="M95.6688 76.4683C95.7339 76.4683 95.799 76.4683 95.799 76.4032C97.3609 74.9715 100.029 73.9302 102.242 73.9302C102.372 73.9302 102.437 73.8 102.437 73.735C102.437 73.6048 102.307 73.5397 102.242 73.5397C99.899 73.5397 97.1657 74.581 95.4736 76.1429C95.4085 76.208 95.3434 76.3382 95.4736 76.4683C95.6037 76.4683 95.6037 76.4683 95.6688 76.4683Z" fill="#1E1826"/>
                  <path d="M97.165 77.5746C97.2301 77.5746 97.2951 77.5746 97.2951 77.5095C98.5968 76.3381 100.484 75.6222 102.046 75.6873C102.176 75.6873 102.306 75.6222 102.306 75.492C102.306 75.3619 102.241 75.2317 102.111 75.2317C100.354 75.1016 98.4015 75.8825 97.0348 77.1841C96.9698 77.2492 96.9698 77.3794 97.0348 77.5095C97.0348 77.5746 97.0999 77.5746 97.165 77.5746Z" fill="#1E1826"/>
                  <text transform="translate(239 1)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0.1875" y="15.9">&#60;150 mm</tspan></text>
                  <text transform="translate(2.00006 56)" fill="black" xml:space="preserve" style="white-space: pre" font-family="Barlow" font-size="16" font-weight="500" letter-spacing="0em"><tspan x="0.46875" y="15.9">&#60;600 mm</tspan></text>
                  </svg>

                <p>{{ toLocal("place.risk_areas") }}</p>
              </div>
              <div
                class="location"
                v-for="(location, index) in locations2"
                :key="index"
              >
                <img :src="require(`@/assets/${location.img}`)" />
                <p>{{ toLocal(location.text) }}</p>
              </div>
            </div>
          </div>
          <div class="red-circle"></div>
        </div>
      </div>
    </div>
    <div class="facts-share">
          <span class="share-title">{{ toLocal("facts.share_story") }}</span>
          <button type="button" @click="mailto">info@eurofsa.org</button>
    </div>
  </div>
</template>

<script>
import HouseComponent from "@/components/House.vue";
import PageHeader from "@/components/PageHeader.vue";

export default {
  components: {
    HouseComponent,
    PageHeader,
  },
  metaInfo: {
    title: "Where To Place Smoke Alarms",
  },
  data() {
    return {
      locations1: [
        {
          img: "images/locations/location1.svg",
          text: "place.ceiling",
        },
        {
          img: "images/locations/location2.svg",
          text: "place.300_mm",
        },
        {
          img: "images/locations/location3.svg",
          text: "place.point",
        },
      ],
      locations2: [
        {
          img: "images/locations/location6.svg",
          text: "place.bedroom",
        },
      ],
      legend: [
        { color: "#a2bae5a8", text: "place.minimum_prot" },
        { color: "#ead40ea9", text: "place.additional_prot" },
        { color: "#d93c2eaf", text: "place.heat_detector" },
        { color: "#6FC06EBD", text: "place.no_alarm" },
      ],
    };
  },
  methods: {
    mailto() {
      window.location.href = "mailto:info@eurofsa.org";
    },
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

/* Reset heading tags to preserve existing styling */
h2.main-header-title,
h3.legend-title {
  margin: 0;
  padding: 0;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  display: block;
}

.page-header {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 1080px;
  background-color: #fbf3ed;
  padding-top: 80px;
  padding-left: 160px;
  padding-right: 160px;
  margin-bottom: -50px;
  box-sizing: border-box;
  @media (max-width: 1280px) {
    padding-left: 80px;
    padding-right: 80px;
  }

  .header-text {
    display: flex;
    flex-direction: column;
    width: 50%;
    font-family: $mainFont;
    justify-content: center;
    align-items: flex-start;
    @media (max-width: 1280px) {
      width: 80%;
    }
    .header-title {
      font-family: $semiBoldFont;
      font-size: 64px;
      margin-bottom: 50px;
    }
    .header-content {
      font-size: 24px;
      text-align: start;
      margin-bottom: 75px;
      width: 80%;
      @media (max-width: 1280px) {
        width: 100%;
      }
    }
    .header-button {
      position: relative;
      width: 380px;
      height: 64px;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #c0554b;
      font-size: 24px;
      font-family: $semiBoldFont;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        height: 12px;
        width: 27px;
        position: absolute;
        top: 28px;
        right: 40px;
      }
      &:hover {
        background-color: #483a5b;
      }
    }
  }
  .page-image-half {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 1280px) {
      margin-left: 100px;
    }
    .cropped-circle {
      position: absolute;
      z-index: 0;
      right: 0;
      top: 350px;
      @media (max-width: 1280px) {
        right: -100px;
        top: 450px;
        max-width: 923px;
        max-height: 923px;
      }
    }
    .top-image {
      z-index: 1;
      height: 45%;
      @media (max-width: 1280px) {
        min-width: 450px;
        max-height: 450px;
      }
    }
  }
}
.types-page-main-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .types-page-main-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 160px 0 160px;
    padding-top: 80px;
    &.bottom {
      padding: 0;
      padding-top: 40px;
    }
    @media (max-width: 1280px) {
      padding: 0 80px 0 80px;
      margin: 16px;
    }
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      margin: 0;
      padding: 0;
      &.bottom {
        padding-top: 20px;
      }
      .main-nav-clickable {
        width: calc(100% - 20px);
        margin-bottom: 16px;
      }
    }
    .main-nav-clickable {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 8px 24px;
      background: #dce3ef;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #1e1826;
      transition: 0.1s;
      flex-wrap: nowrap;
      white-space: nowrap;
      &:hover {
        background-color: $secondaryColor;
        color: white;
        font-family: $semiBoldFont;
      }
    }
  }
}
.main-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: fit-content;
  padding-top: 80px;
  padding-bottom: 80px;
  @media (max-width: 1280px) {
    padding: 0 80px 0 80px;
  }
  .main-header-title {
    margin-top: 75px;
    line-height: clamp(36px, 5vw, 72px);
    font-family: $semiBoldFont;
    text-align: center;
    color: #1e1826;
    margin-bottom: 3rem;
    font-size: clamp(28px, 5vw, 48px);
  }
  .main-header-content {
    font-size: 24px;
    line-height: 32px;
    max-width: 70%;
    text-align: center;
    color: #1e1826;
    margin-bottom: 4rem;
  }
}
.row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  &.white {
    color: white;
    padding: 15px;
    background: #483a5b;
    border-radius: 10px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  }
}
.col {
  &.left {
    padding: 20px 40px 20px 0;
    font-size: 20px;
    line-height: 28px;
    @media (max-width: 1080px) {
      max-width: 60%;
      text-align: start;
    }
    @media (max-width: 768px) {
      max-width: 100%;
    }
    .semibold {
      font-family: $semiBoldFont;
      font-size: 20px;
      line-height: 28px;
    }
  }
}
.recommendations {
  display: flex;
  padding: 50px calc(min(160px, 10vw)) 15%;
  flex-direction: column;
  background: #fbf3ed;
  p {
    margin: 0;
    font-size: 20px;
  }
  .content-column {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 1280px) {
    padding: 5vw 20px 5%;
  }
}
.consider-container {
  display: flex;
  padding: 50px calc(min(160px, 10vw)) 0;
  flex-direction: column;
  align-items: center;
  .row {
    &:last-child {
      margin-bottom: 0;
    }
  }
  h2 {
    text-align: center;
    font-size: clamp(24px, 5vw, 32px);
    margin: 3rem 0;
  }
  .even-text {
    text-align: center;
    width: 80%;
    @media (min-width: 1280px) {
      width: 60%;
    }
  }
  span {
    text-align: center;
    max-width: 80%;
    margin: 2rem 0 4rem;
    font-size: clamp(16px, 5vw, 24px);
  }
}
.card {
  background: white;
  padding: 20px 30px;
  font-size: 20px;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  &.wheat {
    background: #fbf3ed;
    h4 {
      margin-top: 1rem;
      margin-bottom: 2rem;
    }
  }
  &.red {
    background-color: #c0554b;
    color: white;
  }
  h4 {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-family: $semiBoldFont;
  }
}
.mb-40 {
  margin-bottom: 40px;
}
.arrow-right {
  display: flex;
  margin-right: 10px;
  padding-top: 2px;
}
.main-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  .main-content-red-bar {
    position: relative;
    display: flex;
    background-color: $mainColor;
    width: 100%;
    min-height: 300px;
    padding: 15px calc(min(160px, 10vw));
    @media (max-width: 1080px) {
      padding: 15px calc(min(80px, 5vw));
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: none;
      object-position: 0% 61%;
      @media (max-width: 1280px) {
        object-position: 50% 61%;
      }
    }
    .house {
      display: flex;
      flex: 10;
      position: relative;
      width: 100%;
      svg {
        position: absolute;
        left: 0;
        bottom: 0;
        height: auto;
        max-height: 60vh;
      }
      @media (max-width: 1124px) {
        flex: 14;
      }
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 5;
      color: white;
      padding: 1rem 0;
      font-size: clamp(20px, 4vw, 24px);
      max-width: 355px;
      // margin-left: ;
      @media (max-width: 1080px) {
        flex: 4;
      }
      .row {
        display: flex;
        width: 100%;
        .legend {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          background: white;
          padding: calc(min(15px, 10vw)) calc(min(10px, 10vw));
          border-radius: 10px;
          width: 100%;
          max-width: 355px;
          margin-top: 25px;
          .legend-title {
            color: #1e1826;
            font-size: 20px;
            line-height: 24px;
            margin-bottom: 8px;
            @media (max-width: 1080px) {
              font-size: 16px;
              line-height: 18px;
            }
          }
        }
        .legend-item {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1e1826;
          font-size: clamp(14px, 5vw, 16px);
          .legend-color {
            height: 30px;
            min-width: 30px;
            margin: 5px 0;
            margin-right: 5px;
            border-radius: 3px;
          }
          .legend-text {
            @media (max-width: 1980px) {
              text-align: start;
            }
          }
        }
      }
    }
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column-reverse;
      .house {
        position: relative;
        top: 0;
        flex: 1;
        margin: 2rem 0;
        svg {
          position: relative;
          height: auto;
        }
      }
    }
  }
  .main-content-item {
    display: flex;
    box-sizing: border-box;
    padding: 16px;
    background-color: #faf7f5;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    width: 88%;
    @media (max-width: 1280px) {
      width: 90%;
    }
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      padding: 8px;
    }
    &.first {
      margin: 0 auto;
      margin-top: 100px;
    }
    &:not(.first) {
      margin: 21px auto;
    }
    .main-content-image {
      width: 30%;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        width: 80%;
        padding: 8px;
      }
      img {
        width: 100%;
        @media (max-width: 768px) {
          object-fit: fill;
        }
      }
    }
  }
}
.locations {
  position: relative;
  overflow: hidden;
  font-family: $semiBoldFont;
  padding: 70px calc(min(160px, 10vw)) 40px;
  h2,
  h4 {
    font-size: clamp(24px, 4vw, 32px);
    text-align: center;
  }
  h2 {
    font-size: clamp(24px, 5vw, 32px);
  }
  h4 {
    font-size: clamp(18px, 4vw, 24px);
  }
  .content-section {
    display: flex;
    flex-direction: column;
    background: #faf7f5;
    padding: 60px calc(min(165px, 1vw));
    box-shadow: 0 2px 3px 0px #00000052;
    border-radius: 10px;
  }
  .location-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: #1e1826;
    .location {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      max-width: 50%;
      width: 50%;
      height: 40vh;
      max-height: 400px;
      margin: 2rem 0px;
      img {
        display: flex;
        height: 73%;
      }
      p {
        height: 27%;
        text-align: center;
        max-width: 90%;
        margin: calc(min(30px, 5vw)) 0 0;
        font-size: clamp(16px, 5vw, 20px);
        font-family: $mainFont;
      }
    }
  }
  .red-circle {
    position: absolute;
    background: $mainColor;
    z-index: -1;
    right: -30vw;
    bottom: -25vw;
    width: 62vw;
    height: 62vw;
    border-radius: 50%;
  }
  @media (max-width: 768px) {
    padding: 0;
    h2 {
      font-size: clamp(24px, 5vw, 32px);
    }
    h4 {
      font-size: clamp(18px, 5vw, 24px);
    }
    .content-section {
      padding: 20px 20px;
    }
    .location-container {
      flex-direction: column;
      align-items: center;
      .location {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
.main-content-text {
  width: 67.5%;
  margin-left: 2.5%;
  margin-right: 2.5%;
  color: #1e1826;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: $mainFont;
  @media (max-width: 768px) {
    width: 90%;
  }

  .content-text-title {
    font-size: 24px;
    line-height: 32px;
    font-family: $semiBoldFont;
    margin-bottom: 13px;
  }
  .content-text-block {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 16px;
  }
}
@media (max-width: 768px) {
  .main-header {
    padding: 0 20px;
    .main-header-content {
      max-width: 100%;
      margin-bottom: 7vw;
    }
  }
  .has-cols {
    flex-wrap: wrap;
  }
  .col {
    &.left {
      padding-right: 0;
    }
  }
  .recommendations {
    padding: 5vw 20px 15%;
  }
  .main-content .main-content-red-bar {
    padding: 15px 20px;
    .info {
      width: 100%;
      max-width: 100%;
      .row {
        margin-bottom: 15px;
        .legend {
          max-width: 100%;
          .legend-item {
            margin: 0 1vw;
          }
        }
      }
    }
  }
  .consider-container {
    padding: 8vw 20px;
    h2 {
      margin: 1vh 0;
    }
    span {
      width: 100%;
      max-width: 100%;
    }
  }
}
.types-page-main-container .types-page-main-nav {
  margin-top: 1rem;
  &.bottom {
    margin-top: 0;
  }
}
.block-with-number {
  align-self: baseline;
  color: white;
  background: #c0554b;
  min-height: 30px;
  min-width: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 17px;
  margin-right: 10px;
  border-radius: 3px;
}
.semibold {
  font-family: $semiBoldFont;
}
/* Fokusavimo stiliai */
[tabindex="0"]:focus-visible,
button:focus-visible,
a:focus-visible,
:deep(.vueperslides__arrow:focus-visible) {
  outline: 3px solid #000000ff; /* kontrastingas apvadas */
  outline-offset: 4px;
  border-radius: 8px;
}
</style>
